<div class="account-buttons">
  <button *ngIf="hasManagedAccounts()" class="btn managed-btn" (click)="toggleManagedAccounts()"
          aria-label="Verwaltete Accounts">
    <span class="avatar" [ngClass]="{'managed-account-active': isManagingAccount()}">
      <fa-icon [icon]="managedAccountsIcon"></fa-icon>
      <span class="managed-indicator" *ngIf="isManagingAccount()">
        <fa-icon [icon]="switchIcon" class="small-icon"></fa-icon>
      </span>
    </span>
    <span class="managed-label" [ngClass]="{'managed-account-active': isManagingAccount()}">
      <ng-container *ngIf="isManagingAccount(); else managedDefaultLabel">
        {{ getActiveAccountVorname() }} {{ getActiveAccountNachname() }}
        @if (getActiveAccountNameDerInstitution()) {
          ({{ getActiveAccountNameDerInstitution() }})
        }
      </ng-container>
      <ng-template #managedDefaultLabel>Verwaltete Accounts</ng-template>
    </span>
    <span class="icons" [ngClass]="{'show-second': showManagedAccounts}">
      <fa-icon class="icon-default" [icon]="pfeilIcon"></fa-icon>
      <fa-icon class="icon-second" [icon]="pfeilHochIcon"></fa-icon>
    </span>
  </button>
  <button (click)="out = !out" class="btn d-flex flex-row align-items-center">
  <span class="avatar justify-content-center align-items-center d-flex">
    <fa-icon [icon]="userIcon" class="" size="1x"></fa-icon>
  </span>
    <span [ngClass]="{ 'show-second': out }" class="icon x1-5 icons">
    <fa-icon [icon]="pfeilIcon" class="icon-default" size="1x"></fa-icon>
    <fa-icon [icon]="pfeilHochIcon" class="icon-second" size="1x"></fa-icon>
  </span>
  </button>
</div>

<ul #dd class="dd-menu text-center" [ngClass]="{out: out}">
  <li class="p-2 border-bottom font-weight-bold">
    Angemeldet als:<br/>
    {{ userdata.vorname }} {{ userdata.nachname }}
  </li>
  <li class="p-2 font-italic">
    Kundennummer: {{ userdata.kundennummer }}
  </li>
  <li class="p-2 font-italic">
    ({{ userdata.email }})
  </li>
  <li class="p-2">
    <button class="btn btn-sm btn-light w-100" routerLink="/stammdaten" (click)="out=false">
      <fa-icon [icon]="userIcon" class="mr-1"></fa-icon>
      Meine Stammdaten
    </button>
  </li>
  <li class="p-2">
    <button class="btn btn-sm btn-light w-100 shrink-top-animated" [class.out]="!loggingOut" (click)="logout()">
      <fa-icon [icon]="logoutIcon" class="mr-1"></fa-icon>
      Abmelden
    </button>
    <span
      [class.out]="loggingOut"
      class="w-100 text-center shrink-top-animated"
    >
      <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
    </span>
  </li>
</ul>

<ul class="dd-menu managed-menu" *ngIf="hasManagedAccounts()" [ngClass]="{out: showManagedAccounts}">
  <li class="p-2 font-weight-bold text-center">
    <ng-container *ngIf="isManagingAccount(); else managedTitle">
      Aktiver Account: {{ getActiveAccountVorname() }} {{ getActiveAccountNachname() }}
      @if (getActiveAccountNameDerInstitution()) {
        ({{ getActiveAccountNameDerInstitution() }})
      }
    </ng-container>
    <ng-template #managedTitle>Verwaltete Accounts</ng-template>
  </li>
  <li class="p-2 text-center small" *ngIf="isManagingAccount()">
    Kundennummer: {{ getActiveAccountKundennummer() }}
  </li>
  <li class="p-2" *ngIf="isManagingAccount()">
    <button class="btn btn-sm btn-primary w-100" (click)="returnToVerwalterAccount()">
      <fa-icon [icon]="switchIcon" class="mr-1"></fa-icon>
      Zurück zum Verwalter-Account
    </button>
  </li>

  <!-- List of managed accounts -->
  <li class="p-2 border-top text-center" *ngIf="managedAccounts.length === 0">
    <span class="text-muted">Keine verwalteten Accounts vorhanden</span>
  </li>
  <li class="p-2 border-top" *ngFor="let account of managedAccounts">
    <button class="btn btn-sm btn-outline-primary w-100" (click)="switchToAccount(account)">
      <fa-icon [icon]="switchIcon" class="mr-1"></fa-icon>
      {{ account.vorname }} {{ account.nachname }}
      @if (account.name_der_institution) {
        ({{ account.name_der_institution }})
      }
    </button>
  </li>
</ul>
